export const actions = {
  M365_DISABLE_USER: 'M365_DISABLE_USER', // Block Sign-in
  M365_ENABLE_USER_MFA: 'M365_ENABLE_USER_MFA', // Enable user MFA
  M365_ENABLE_USER: 'M365_ENABLE_USER', // Unblock Sign-in (This is used internally for the integration manager, the actual task name is still M365_DISABLE_USER)
  M365_MANAGE_GROUPS: 'M365_MANAGE_GROUPS', // Manage M365 groups
  M365_MANAGE_SHARED_GROUPS: 'M365_MANAGE_SHARED_GROUPS', // Manage Shared groups
  M365_MANAGE_DISTRIBUTION_GROUPS: 'M365_MANAGE_DISTRIBUTION_GROUPS', // Manage distribution / MailEnabled Security groups
  M365_MANAGE_SECURITY_GROUPS: 'M365_MANAGE_SECURITY_GROUPS', // Manage Security groups
  M365_RE_REGISTER_MFA: 'M365_RE_REGISTER_MFA', // Re-register MFA
  M365_TEMPORARY_ACCESS_PASS: 'M365_TEMPORARY_ACCESS_PASS', // Temporary Access Pass
}
